import { useArrayFilter } from "@vueuse/core";
import { computed, toValue } from "vue";
import { useFuzzySearch } from "../../common/fuzzy-search";
import { havingAllTags, havingAnyTags, excludeHavingAllTags, excludeHavingAnyTags, } from "src/shared/Tags";
export const filterDuplicatableComponentsByListRequest = (components, data) => {
    return components.filter((component) => {
        return (havingAllTags(component, data.havingAllTags) &&
            havingAnyTags(component, data.havingAnyTags) &&
            excludeHavingAllTags(component, data.excludeHavingAllTags) &&
            excludeHavingAnyTags(component, data.excludeHavingAnyTags) &&
            (data.clientIds.length === 0 ||
                data.clientIds.includes(component.source_client_id)));
    });
};
export const useFilteredDuplicatableComponents = (parameters) => {
    const filtered = useFuzzySearch(parameters.search, parameters.components, [
        "name",
        "display_name",
    ]);
    const filteredByClientId = computed(() => {
        return filterDuplicatableComponentsByListRequest(filtered.value, {
            clientIds: toValue(parameters.clientIds),
        });
    });
    const filteredByDeprecatedType = useArrayFilter(filteredByClientId, (component) => {
        const havingAllTypesValue = toValue(parameters.havingAllDeprecatedTypes) || [];
        return (havingAllTypesValue.length === 0 ||
            havingAllTypesValue.every((type) => component.types.map(String).includes(type)));
    });
    return {
        filteredComponents: filteredByDeprecatedType,
    };
};
